import * as Yup from "yup";

const validationSchema = (schema: any) => {
  const valid = Yup.object({
    title: Yup.string().required(schema.isRequired),
    titleAr: Yup.string().required(schema.isRequired),
    price: Yup.number().typeError(schema.isNumber).required(schema.isRequired),
  });
  return valid;
};

export default validationSchema;
